<template>
  <div class="channels_wrap">
    <BreadCrumb crumb="频道管理"></BreadCrumb>
    <div class="top_bar">
      <el-row>
          <el-col :span="5">
            <el-input placeholder="请输入搜索内容: 频道" v-model="keyword" class="input-with-select" size="small">
              <!-- <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button> -->
            </el-input>
          </el-col>

          <el-col :span="5" :offset='1'>
              <template>
                <el-select  size="small" v-model="is_visible" placeholder="请选择状态">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
          </el-col>

          <el-col :span="2" >
            <div class="find" @click='fnGetData(1)'>查询</div>
          </el-col>

          <el-col :span="3" :offset="8"><Addchannels @fnResetTable="fnGetData"></Addchannels></el-col>

      </el-row>
    </div>


    <ChannelsTable :channels="aChannelsList" @fnResetTable="fnGetData"></ChannelsTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import Addchannels from '@/components/widget/Addchannels'
import ChannelsTable from '@/components/widget/ChannelsTable'
import cons from '@/components/constant'

export default {
  name: 'Channels',
  data () {
    return {
      options: [{
          value: '0',
          label: '不可见'
        },
        {
          value: '1',
          label: '可见'
        }
      ],
      page:1,
      pages:8,
      pagesize:10,
      keyword: '',
      is_visible : '',
      aChannelsList:[]
    }
  },
  components:{
    BreadCrumb,
    Addchannels,
    ChannelsTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/channels', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            order_by: 'id',
            is_visible: this.is_visible===''?1:this.is_visible,
            keyword: this.keyword,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          // console.log(dat);
          this.aChannelsList = dat.data.data.channels;
          // this.aChannelsList.reverse()
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto;
  }

.batch_operation, .export_data {
  width: 80px;
  height: 32px;
  color: #fff;
  font: 12px/32px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.batch_operation:hover, .export_data:hover {
  background-color: rgb(252, 119, 121);
}

.find {
  width: 92px;
  height: 38px;
  color: #fff;
  font: 12px/38px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.find {
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-left: 140px;
}
.batch_operation:hover, .export_data:hover, .find:hover {
  background-color: rgb(252, 119, 121);
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Channels.vue